import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { getMedia } from "../Service/Api";
import LazyLoad from "react-lazyload";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const getImageUrl = (id) =>
  `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${id}`;

const MediaCoverage = () => {
  useEffect(() => {
    document.title =
      "MediaCoverage - Mar Gregorios Memorial Hr. Sec. School, Bokaro";
  }, []);

  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [yearRanges, setYearRanges] = useState([]);
  const [availableMonths, setAvailableMonths] = useState([]); // kept, if you need later
  const [searchQuery, setSearchQuery] = useState("");

  const [isLightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxItem, setLightboxItem] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const monthsOfYear = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const handleMonth = (month) => monthsOfYear[month - 1];

  useEffect(() => {
    (async () => {
      try {
        const galleryData = await getMedia();
        if (!Array.isArray(galleryData)) return;
        setData(galleryData);

        const uniqueYears = Array.from(
          new Set(
            galleryData
              .map((item) =>
                item.date ? new Date(item.date).getFullYear() : null,
              )
              .filter((y) => y !== null),
          ),
        ).sort((a, b) => b - a);
        setYearRanges(uniqueYears);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  useEffect(() => {
    let filtered = [...data];
    const monthsSet = new Set();

    if (selectedYear !== "All") {
      filtered = filtered.filter((item) => {
        if (!item.date) return false;
        const d = new Date(item.date);
        const y = d.getFullYear();
        if (parseInt(selectedYear) === y) {
          monthsSet.add(d.getMonth() + 1);
          return true;
        }
        return false;
      });
    } else {
      filtered.forEach((item) => {
        if (item.date) monthsSet.add(new Date(item.date).getMonth() + 1);
      });
    }

    setAvailableMonths([...monthsSet].sort((a, b) => a - b));

    if (selectedMonth !== "All") {
      filtered = filtered.filter(
        (item) =>
          item.date &&
          new Date(item.date).getMonth() + 1 === parseInt(selectedMonth),
      );
    }

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter((item) =>
        item.title?.toLowerCase().includes(q),
      );
    }

    setFilteredData(filtered);
  }, [selectedYear, selectedMonth, searchQuery, data]);

  const openLightbox = (item, startIndex = 0) => {
    setLightboxItem(item);
    setLightboxIndex(startIndex);
    setLightboxOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxItem(null);
    setLightboxIndex(0);
    document.body.style.overflow = "";
  };

  useEffect(() => {
    if (!isLightboxOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight")
        setLightboxIndex((i) =>
          Math.min(i + 1, (lightboxItem?.attachments?.length || 1) - 1),
        );
      if (e.key === "ArrowLeft") setLightboxIndex((i) => Math.max(i - 1, 0));
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isLightboxOpen, lightboxItem]);

  const lightboxImages = useMemo(() => {
    const att = Array.isArray(lightboxItem?.attachments)
      ? lightboxItem.attachments.filter(Boolean)
      : [];
    return att.length ? att.map(getImageUrl) : [];
  }, [lightboxItem]);

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li>Media</li>
          <li>Media Coverage</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Media Coverage</h1>
            </div>
          </div>

          <div className="row tabs-dynamic">
            <div className="col-md-3">
              <div className="count-val">
                <p>Total Count: {filterData.length}</p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="month-selection">
                <select
                  id="yearSelection"
                  onChange={(e) => setSelectedYear(e.target.value)}
                  value={selectedYear}
                >
                  <option value="All">All Years</option>
                  {yearRanges.map((yr, idx) => (
                    <option key={idx} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-6">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  autoComplete="off"
                  placeholder="Search Here.."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="clr"></div>

          <div className="row media-cover">
            {filterData.length > 0
              ? filterData.map((item, index) => {
                  const attachments = Array.isArray(item?.attachments)
                    ? item.attachments.filter(Boolean)
                    : [];
                  const imageList = attachments.length
                    ? attachments.map(getImageUrl)
                    : [
                        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/magzine.png",
                      ];
                  return (
                    <div
                      key={index}
                      className="col-lg-3 col-md-6 col-sm-6 col-6 fullwidth magzine"
                    >
                      <div className="media-thumb">
                        <Slider {...sliderSettings}>
                          {imageList.map((imgSrc, imgIndex) => (
                            <div key={`${item?._id || index}-${imgIndex}`}>
                              <button
                                type="button"
                                className="media-slide-btn"
                                onClick={() => openLightbox(item, imgIndex)}
                                aria-label={`Open ${item?.title || "image"} gallery image ${imgIndex + 1}`}
                              >
                                <LazyLoad>
                                  <img
                                    src={imgSrc}
                                    className="img-fluid"
                                    alt={item?.title || "Media Coverage"}
                                  />
                                </LazyLoad>
                              </button>
                            </div>
                          ))}
                        </Slider>
                        <h4>{item?.title || "Media Item"}</h4>
                      </div>
                      {/* Optional: keep external link to article if you have item.url */}
                      {item?.url && (
                        <div className="mt-1 text-center">
                          <a href={item.url} target="_blank" rel="noreferrer">
                            View
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })
              : Array(4)
                  .fill()
                  .map((_, idx) => (
                    <div
                      key={idx}
                      className="col-lg-3 col-md-6 col-sm-6 col-6 fullwidth magzine"
                    >
                      <div className="media-thumb disabled">
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/magzine.png"
                            className="img-fluid"
                            alt="No Media Available"
                          />
                        </LazyLoad>
                        <h4>Title</h4>
                      </div>
                    </div>
                  ))}
          </div>
        </div>
      </div>

      {/* LIGHTBOX */}
      {isLightboxOpen && (
        <div
          className="lightbox-overlay"
          onClick={closeLightbox}
          role="dialog"
          aria-modal="true"
        >
          <div className="lightbox" onClick={(e) => e.stopPropagation()}>
            <button
              className="lb-close"
              onClick={closeLightbox}
              aria-label="Close"
            >
              ×
            </button>

            <div className="lb-main">
              {lightboxImages.length > 1 && (
                <button
                  className="lb-nav lb-prev"
                  onClick={() => setLightboxIndex((i) => Math.max(i - 1, 0))}
                  disabled={lightboxIndex === 0}
                  aria-label="Previous image"
                >
                  ‹
                </button>
              )}

              <img
                src={lightboxImages[lightboxIndex] || ""}
                alt={lightboxItem?.title || "Media image"}
                className="lb-image"
                draggable={false}
              />

              {lightboxImages.length > 1 && (
                <button
                  className="lb-nav lb-next"
                  onClick={() =>
                    setLightboxIndex((i) =>
                      Math.min(i + 1, lightboxImages.length - 1),
                    )
                  }
                  disabled={lightboxIndex === lightboxImages.length - 1}
                  aria-label="Next image"
                >
                  ›
                </button>
              )}
            </div>

            {lightboxImages.length > 0 && (
              <div className="lb-thumbs">
                {lightboxImages.map((src, i) => (
                  <button
                    key={i}
                    className={`lb-thumb ${i === lightboxIndex ? "active" : ""}`}
                    onClick={() => setLightboxIndex(i)}
                    aria-label={`Go to image ${i + 1}`}
                    title={`Image ${i + 1}`}
                  >
                    <img src={src} alt={`thumb ${i + 1}`} />
                  </button>
                ))}
              </div>
            )}

            <div className="lb-caption">
              <div className="lb-title">{lightboxItem?.title || ""}</div>
              {lightboxItem?.date && (
                <div className="lb-meta">
                  {new Date(lightboxItem.date).toLocaleDateString(undefined, {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MediaCoverage;
